<template>

  <div class="error-page">
    <div class="img">
      <img src="../static/img/error/404.png" alt="抱歉，页面找不到了。">
    </div>
    <div class="btn">
      <el-button @click="backIndex">返回</el-button>
    </div>
  </div>

</template>
<script>


  export default {
    components: {},
    name: "index",
    data() {
      return {}
    },
    watch: {},
    computed: {},

    methods: {
      backIndex() {
        this.$router.go(-1)
      },
    },
    mounted() {

    },
    created() {
    }
  }
</script>

<style lang="scss" scoped>
  .error-page {
    text-align: center;

    .img {
      img {
        width: 100%;
        max-width: 1200px;
      }
    }

    .btn {
      margin-top: 40px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/error.vue